<div id="fullscreen">
	<router-outlet></router-outlet>
	<app-popup></app-popup>
</div>